module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-ellipse-mobile-app-3a6bb31efd525d8ff094f72aae30e8f1.png";